module.exports = __webpack_public_path__ + "img/members-become-enjoy.09499e19.png";